import { render, staticRenderFns } from "./NewAccountDetailPage.vue?vue&type=template&id=3924333f&scoped=true"
import script from "./NewAccountDetailPage.vue?vue&type=script&lang=js"
export * from "./NewAccountDetailPage.vue?vue&type=script&lang=js"
import style0 from "./NewAccountDetailPage.vue?vue&type=style&index=0&id=3924333f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924333f",
  null
  
)

export default component.exports